import request from '@/utils/request'

//获取用户列表
export function getUserList(data) {
    return request({
        url: '/backend/user/getUserList',
        method: 'post',
        data: data
    })
}

//获取用户详情
export function getUserInfo(data) {
    return request({
        url: '/backend/user/getUserInfo',
        method: 'post',
        data: data
    })
}

//获取用户完整手机号
export function getFullMobile(data) {
    return request({
        url: '/backend/user/getFullMobile',
        method: 'post',
        data: data
    })
}

//获取会员期限
export function getUserVIP(data) {
    return request({
        url: '/backend/user/getUserVIP',
        method: 'post',
        data: data
    })
}

//更换用户分会
export function updateUserAgent(data) {
    return request({
        url: '/backend/user/updateUserAgent',
        method: 'post',
        data: data
    })
}

//更新用户会员期限
export function updateUserVIPLevel(data) {
    return request({
        url: '/backend/user/updateUserVIPLevel',
        method: 'post',
        data: data
    })
}

//学习记录列表
export function getUserStudyRecords(data) {
    return request({
        url: '/backend/user/getUserStudyRecords',
        method: 'post',
        data: data
    })
}

//评论列表
export function getUserComment(data) {
    return request({
        url: '/backend/user/getUserComment',
        method: 'post',
        data: data
    })
}
//删除评论
export function userCommentDelete(data) {
    return request({
        url: '/backend/user/userCommentDelete',
        method: 'post',
        data: data
    })
}
//审核评论
export function auditCourseComment(data) {
    return request({
        url: '/backend/user/auditCourseComment',
        method: 'post',
        data: data
    })
}
//回复评论
export function replyCourseComment(data) {
    return request({
        url: '/backend/user/replyCourseComment',
        method: 'post',
        data: data
    })
}

//学习记录列表
export function getUserStudyList(data) {
    return request({
        url: '/backend/user/getUserStudyList',
        method: 'post',
        data: data
    })
}

//修改密码接口
export function modifyPassword(data) {
    return request({
        url: '/backend/user/modifyPassword',
        method: 'post',
        data: data
    })
}

//获取用户天使币记录
export function getUserPointLog(data) {
    return request({
        url: '/backend/user/getUserPointLog',
        method: 'post',
        data: data
    })
}

//获取用户测评记录
export function getUserTestLog(data) {
    return request({
        url: '/backend/user/getUserTestLog',
        method: 'post',
        data: data
    })
}

//获取测评详情
export function getTestResult(data) {
    return request({
        url: '/backend/user/getUserTestResult',
        method: 'post',
        data: data
    })
}